import { INotification } from "infrastructure/notification";

import { IAccount } from "../models";

export interface IRoleAssignmentEvent {
  account: IAccount;
  author: IAccount;
  committedTime: string;
  action: string;
}

export interface IRoleMembersHistoryInitData {
  tenantId: string;
  securityRoleId: string;
}

export interface IRoleMembersHistoryDateRange {
  dateFrom: string;
  dateTo: string;
}

export interface IRoleMembersHistoryFilter {
  account?: IAccount;
  dateRange?: IRoleMembersHistoryDateRange;
}

export interface IRoleMembersHistoryState {
  initData: IRoleMembersHistoryInitData;
  isLoading: boolean;
  notifications: INotification[];
  filter?: IRoleMembersHistoryFilter;
  data?: IRoleAssignmentEvent[];
}

export const getInitialRoleMembersHistoryState = (): IRoleMembersHistoryState => ({
  isLoading: false,
  data: undefined,
  notifications: [],
  initData: { tenantId: "", securityRoleId: "" },
  filter: undefined
});
